export const perPageValues = [5, 10, 15, 20, 30, 50, 75, 100]

export const getPerPageOptions = () => {
    return perPageValues.map((perPageValue) => ({
        label: perPageValue,
        value: perPageValue,
    }))
}
